module.exports = "/static/assets/cdad5959f5916f1de3a6e086b7756c2c.png";